import { render, staticRenderFns } from "./FinanceDepositSlip.vue?vue&type=template&id=c072c630&"
import script from "./FinanceDepositSlip.vue?vue&type=script&lang=js&"
export * from "./FinanceDepositSlip.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDepositSlip.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports